import React from 'react';

const ConsentStep = ({ register, errors }) => {
    return (
        <div>
            <h4 className="mb-4">
                <i className="fas fa-handshake me-2 text-primary"></i>
                Consent & Agreement
            </h4>

            <div className="alert alert-warning mb-4">
                <h6><i className="fas fa-exclamation-triangle me-2"></i>Please read and agree to the following</h6>
                <p className="mb-0">By proceeding, you acknowledge that you have read and understood our terms and conditions.</p>
            </div>

            {/* Contact Agreement */}
            <div className="card mb-4">
                <div className="card-body">
                    <div className="form-check">
                        <input
                            className={`form-check-input ${errors.agreeToContact ? 'is-invalid' : ''}`}
                            type="checkbox"
                            {...register('agreeToContact')}
                            id="agreeToContact"
                        />
                        <label className="form-check-label" htmlFor="agreeToContact">
                            <strong>I agree to be contacted for updates and confirm that the information provided is accurate</strong> *
                        </label>
                        {errors.agreeToContact && (
                            <div className="invalid-feedback d-block">{errors.agreeToContact.message}</div>
                        )}
                    </div>
                    <small className="text-muted mt-2 d-block">
                        <i className="fas fa-info-circle me-1"></i>
                        We will use your contact information to send you updates about the training program when necessary.
                    </small>
                </div>
            </div>

            {/* Media Consent */}
            {/*<div className="card mb-4">*/}
            {/*    <div className="card-body">*/}
            {/*        <div className="form-check">*/}
            {/*            <input*/}
            {/*                className="form-check-input"*/}
            {/*                type="checkbox"*/}
            {/*                {...register('consentToMedia')}*/}
            {/*                id="consentToMedia"*/}
            {/*            />*/}
            {/*            <label className="form-check-label" htmlFor="consentToMedia">*/}
            {/*                <strong>I consent to photos/videos taken during training to be used for promotional purposes</strong>*/}
            {/*            </label>*/}
            {/*        </div>*/}
            {/*        <small className="text-muted mt-2 d-block">*/}
            {/*            <i className="fas fa-camera me-1"></i>*/}
            {/*            This is optional. Photos and videos may be used on our website, social media,*/}
            {/*            and marketing materials to showcase our training programs.*/}
            {/*        </small>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/* Data Protection Notice */}
            <div className="alert alert-info">
                <h6><i className="fas fa-shield-alt me-2"></i>Data Protection Notice</h6>
                <p className="mb-2">
                    Your personal data will be processed in accordance with our Privacy Policy.
                    We are committed to protecting your privacy and will only use your information
                    for the purposes of this training program.
                </p>
                <ul className="mb-0 small">
                    <li>Your data will be stored securely and not shared with third parties</li>
                    <li>You have the right to request access, correction, or deletion of your data</li>
                    <li>We will retain your data only for as long as necessary for the training program</li>
                </ul>
            </div>

            {/* Terms Summary */}
            <div className="card bg-light">
                <div className="card-body">
                    <h6><i className="fas fa-file-contract me-2"></i>Training Program Terms</h6>
                    <div className="row">
                        <div className="col-md-6">
                            <ul className="list-unstyled small">
                                <li><i className="fas fa-check text-success me-2"></i>Free training with no hidden costs</li>
                                <li><i className="fas fa-check text-success me-2"></i>Industry-certified instructors</li>
                                <li><i className="fas fa-check text-success me-2"></i>Hands-on practical training</li>
                                <li><i className="fas fa-check text-success me-2"></i>Career guidance and mentorship</li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul className="list-unstyled small">
                                <li><i className="fas fa-exclamation-circle text-warning me-2"></i>Regular attendance required (80% minimum)</li>
                                <li><i className="fas fa-exclamation-circle text-warning me-2"></i>Complete all assignments and projects</li>
                                <li><i className="fas fa-exclamation-circle text-warning me-2"></i>Respect training guidelines and policies</li>
                                <li><i className="fas fa-exclamation-circle text-warning me-2"></i>Commitment to full training duration</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConsentStep;